'use strict';

module Patersons {

    export abstract class AbstractController {
        baseUrl: string;
        rootScope: any;
        location: ng.ILocationService;
        window: ng.IWindowService;
        state: angular.ui.IStateService;
        stateParams: angular.ui.IStateProvider;
        http: ng.IHttpService;
        log: ng.ILogService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope) {

            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.rootScope = $rootScope;
            this.log = $log;
            var model: string = document.getElementById("model").textContent.trim();
            var dictionary: any = JSON.parse(model);
            this.baseUrl = dictionary['hostPath'];
            var userId = dictionary['userId'];
        }
        redirect(url: string) {
            this.location.url(url);
            this.window.location.href = url;
            this.window.location.reload();
        }
        errorHandler(msg, Url) {
            msg = msg || "Unexpected Error";
            var self = this;

            return function (response) {
                if (response.data.exceptionMessage) {
                    this.log.error(response.data.exceptionMessage);
                }
                this.rootScope.$emit('error', { error: msg, url: Url });
                throw (response.data.errors || response.data.message || msg);
            }
        }
    }
}
